import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDsUwzo1jZU4f4dR5nY0S8zDlcJGwTQevk",
  authDomain: "ikoki-31b19.firebaseapp.com",
  projectId: "ikoki-31b19",
  storageBucket: "ikoki-31b19.firebasestorage.app",
  messagingSenderId: "111285025852",
  appId: "1:111285025852:web:b5392fe855da6780d05739",
  measurementId: "G-76SZG9LYVX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Get the default firestore instance
export const db = getFirestore(app);
